import { usePortalModeStore } from "@stores/usePortalModeStore"
import { ModalsProvider } from "@mantine/modals"
import { TanStackDevtools } from "@tanstack/react-devtools"
import { ReactQueryDevtoolsPanel } from "@tanstack/react-query-devtools"
import { Outlet } from "@tanstack/react-router"
import { TanStackRouterDevtoolsPanel } from "@tanstack/react-router-devtools"
import { RouterAuthSync } from "./RouterAuthSync"

export const Root: React.FC = () => {

    const viewMode = usePortalModeStore((state) => state.viewMode)
    
    return (
        <main className={'w-screen h-screen overflow-hidden dark:scheme-dark'} key={viewMode}>
            <ModalsProvider
                modalProps={{
                    radius: 'lg',
                }}
            >
                <Outlet />
            </ModalsProvider>
            <RouterAuthSync />
            {/* <TanStackDevtools plugins={[
                    {
                        name: 'TanStack Query',
                        render: <ReactQueryDevtoolsPanel />,
                    },
                    {
                        name: 'TanStack Router',
                        render: <TanStackRouterDevtoolsPanel />,
                    },
                ]} 
            /> */}
        </main>
    )
}
